module.exports = __webpack_public_path__ + "static/fonts/Roboto-Regular.5673da52.ttf";